import type { ChatMessage } from '../constants/mocks/messages';

export const filterMessagesForDisplay = (messages: ChatMessage[]): ChatMessage[] => {
  const latestProposalId = messages.filter(m => m.type === 'proposal').slice(-1)[0]?.id;

  return messages.filter(message => {
    if (message.type === 'proposal' && message.id !== latestProposalId) {
      return false;
    }
    return true;
  });
};
